import { Adver, AdverFormData } from "../types/adver";
import { ApiResponse } from "../types/api";
import { api } from "./api";

export const adverService = {
  // 모든 광고 조회
  getAllAdvers: async (): Promise<Adver[]> => {
    const response = await api.get<ApiResponse<Adver[]>>("/api/admin/ads");
    return response.data.data;
  },

  // ID로 광고 조회
  getAdverById: async (id: number): Promise<Adver> => {
    const response = await api.get<ApiResponse<Adver>>(`/api/admin/ads/${id}`);
    return response.data.data;
  },

  // 광고 생성
  createAdver: async (
    formData: AdverFormData,
    imageFile?: File,
  ): Promise<Adver> => {
    // multipart/form-data 생성
    const multipartData = new FormData();
    multipartData.append("data", JSON.stringify(formData));
    if (imageFile) {
      multipartData.append("image", imageFile);
    }

    const response = await api.post<ApiResponse<Adver>>(
      "/api/admin/ads",
      multipartData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data.data;
  },

  // 광고 수정
  updateAdver: async (
    id: number,
    formData: AdverFormData,
    imageFile?: File,
  ): Promise<Adver> => {
    // multipart/form-data 생성
    const multipartData = new FormData();
    // 수정 시에는 기존 imageUrl을 data에 포함해야 함
    multipartData.append("data", JSON.stringify(formData));
    if (imageFile) {
      multipartData.append("image", imageFile);
    }

    const response = await api.put<ApiResponse<Adver>>(
      `/api/admin/ads/${id}`,
      multipartData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data.data;
  },

  // 광고 삭제
  deleteAdver: async (id: number): Promise<void> => {
    await api.delete(`/api/admin/ads/${id}`);
  },
};
